import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { FaqCrudIndex } from './crud-index';
import { COLUMNS_TO_SELECT } from '../crud-config';
import { FaqService } from '../crud-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-faq-events-select-index',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [FaqService],
})
export class FaqIndexSelectComponent extends FaqCrudIndex {
  override title: string = 'SELECIONE A RESPOSTA';
  displayedColumnsToSelect = COLUMNS_TO_SELECT;

  constructor(
    override dialog: MatDialog,
    override service: FaqService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    override router: Router,
    public dialogRefSelect: MatDialogRef<FaqIndexSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
    }
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    this.dataSelect = data;
  }

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }
}
